<div class="contain-content">
    <component-login *ngIf="!isAuthenticated"></component-login>

    <ng-container *ngIf="isAuthenticated"></ng-container>
</div>
